// extracted by mini-css-extract-plugin
export var aircallIframe = "_i4-3";
export var fabContainer = "_i4-5";
export var fabRinging = "_i4-6";
export var loadingOverlay = "_i4-4";
export var pulse = "_i4-7";
export var widgetContent = "_i4-2";
export var widgetPanel = "_i4-0";
export var widgetPanelExpanded = "_i4-1";